export interface RegistrarJuradoModel {
  path_foto: string;
  perfil: string;
  tipo_identificacion: string;
  numero_documento: string;
  dia_nacimiento: string;
  mes_nacimiento: string;
  año_nacimiento: string;
  primer_nombre: string;
  segundo_nombre: string;
  primer_apellido: string;
  segundo_apellido: string;
  genero: string;
  orientacion_sexual: string;
  identidad_genero: string;
  path_documento: string;
  etnia: string;
  telefono_celular: string;
  telefono_fijo: string;
  pais_nacimiento: string;
  departamento_residencia: string;
  municipio_residencia: string;
  comuna_residencia: string;
  barrio: string;
  direccion: string;
  estrato: string;
  correo_electronico: string;
  fecha_nacimiento: string;
}

export const initialValuesRegistrarJuradoModel = {
  path_foto: "",
  perfil: "",
  tipo_identificacion: "",
  numero_documento: "",
  fecha_nacimiento: "",
  dia_nacimiento: "",
  mes_nacimiento: "",
  año_nacimiento: "",
  primer_nombre: "",
  segundo_nombre: "",
  primer_apellido: "",
  segundo_apellido: "",
  genero: null,
  orientacion_sexual: null,
  identidad_genero: null,
  path_documento: "",
  etnia: null,
  telefono_celular: "",
  telefono_fijo: "",
  pais_nacimiento: null,
  departamento_residencia: null,
  municipio_residencia: null,
  comuna_residencia: null,
  barrio: null,
  direccion: "",
  estrato: "",
  correo_electronico: "",
};
